export default __webpack_public_path__ + "static/media/product.11f6e586.jpg";